import { z } from "zod/v4";

// One club from the public discovery directory (grouped scraped-DVV athletes,
// slug generated from the club name). Distinct from the community `Club`
// entity in schemas/club.ts — directory clubs power the public onsand.app
// pages and the embeddable ranking widget.
export const directoryClubSchema = z.object({
	slug: z.string(),
	name: z.string(),
	federation: z.string(),
	athlete_count: z.number().int(),
	logo_url: z.string().nullable().optional(),
	website: z.string().nullable().optional(),
});

export type DirectoryClub = z.infer<typeof directoryClubSchema>;

export const directoryClubListResponseSchema = z.object({
	items: z.array(directoryClubSchema),
	total: z.number().int(),
});
